import { useTheme } from 'next-themes'
import { Toaster as Sonner, toast } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      position="bottom-center"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:rounded-lg group-[.toaster]:bg-frame group-[.toaster]:text-white group-[.toaster]:border-0 group-[.toaster]:shadow-bar',
          description: 'group-[.toast]:text-sidebar-foreground',
          actionButton: 'group-[.toast]:bg-card group-[.toast]:text-ink',
          cancelButton: 'group-[.toast]:bg-sidebar-hover group-[.toast]:text-sidebar-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
